import { RouteType } from "types/RouteType";
import InventoryAdjustmentsWizardStore from "./InventoryAdjustmentsWizardStore";

const InventoryAdjustmentsWizardRoute: RouteType = {
  name: "InventoryAdjustmentsWizard",
  path: "/workflows/inventory-adjustments",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Inventory Adjustments",
      component: () => import("./InventoryAdjustmentsWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./InventoryAdjustmentsWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!(rootStore as any).inventoryAdjustmentsWizardStore) {
      (rootStore as any).inventoryAdjustmentsWizardStore =
        new InventoryAdjustmentsWizardStore(rootStore);
    }
    await (rootStore as any).inventoryAdjustmentsWizardStore.loadInitialData();
    return true;
  },
};

export default InventoryAdjustmentsWizardRoute;
